import React from "react";
import { Dialog } from "./Dialog";
import { Button } from "./Button";

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  loading?: boolean;
  tone?: "default" | "danger";
  sheet?: boolean;
}

/** Confirm/cancel convenience over ui/Dialog. Collapses the ~11 confirm modals. */
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  loading,
  tone = "default",
  sheet,
}) => (
  <Dialog.Root open={open} onOpenChange={(o) => { if (!o && !loading) onOpenChange(false); }}>
    <Dialog.Content
      sheet={sheet}
      className="max-w-[420px] p-[26px]"
      {...(description ? {} : { "aria-describedby": undefined })}
    >
      <Dialog.Title className="text-[18px] font-bold text-white">{title}</Dialog.Title>
      {description && (
        <Dialog.Description className="mt-2 text-[13.5px] text-muted">{description}</Dialog.Description>
      )}
      <div className="mt-6 flex items-center justify-end gap-3">
        <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          loading={loading}
          className={tone === "danger" ? "!bg-danger !text-white !shadow-none hover:!brightness-110" : undefined}
        >
          {confirmLabel}
        </Button>
      </div>
    </Dialog.Content>
  </Dialog.Root>
);

export default ConfirmDialog;
